<template>
  <div>
    
    <div v-if="!rows.length">
      <div class="webkit-animation webkit-100-440"></div>
    </div>

      <swiper
          style="height: 100vh !important"
          ref="mySwiper"
          :options="swiperOptions"
        >

          <swiper-slide v-for="(row, index) in rows" :key="index"
            :style="'background-image: url('+row.file+');background-size: cover'"
             :data-swiper-autoplay="row.duration + '000'">
            <div class="container-fluid">
              <div class="bg-title white-color"
                  v-html="row.title"
                  :style="'color:'+row.color+' !important;white-space:break-spaces'">
              </div>
              <router-link v-if="row.button" :to="row.redirect" class="btn-line btn-line-white">
                {{ row.button }}
              </router-link>
            </div>
          </swiper-slide>
          <!-- If we need pagination -->
          <div class="swiper-pagination" slot="pagination"></div>
        
      </swiper>

  </div>
</template>


<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

import axios from "axios";
export default {
  name: "Slider",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      pgLoading: true,
      rows: [],

      swiperOptions: {
          autoplay: true,
          pagination: {
            el: '.swiper-pagination'
          },
          // pagination: '.swiper-pagination'
          // Some Swiper option/callback...
      },

    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  },
  created() {
      //
    this.fetchSlider();
  },
  methods: {
      
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
        })
        .catch(() => {});
    },


  },
};
</script>
